import { render } from "./post.vue?vue&type=template&id=4289ae28&scoped=true"
import script from "./post.vue?vue&type=script&lang=js"
export * from "./post.vue?vue&type=script&lang=js"

import "./post.vue?vue&type=style&index=0&id=4289ae28&scoped=true&lang=css"

import exportComponent from "/media/whoami/010101010/Prosofty/PublicOpinion/frontEnd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4289ae28"]])

export default __exports__